import PassPageContext from 'components/PassPageContext'
import VisualTodoNote from 'components/VisualTodoNote'
import React from 'react'

const isBrowser = typeof window !== "undefined"

class ComponentScreenshot extends React.Component {
  getScreenshotInfo = pageContext => {
    const { component, name } = this.props

    const screenshots = pageContext.componentScreenshots[component]

    if (!screenshots) {
      console.log(`No screenshot available for ${component}, ${name}`)
      return null
    }

    const mobile = screenshots.mobile

    const desktop = screenshots.desktop

    // Instead of matching user agent, just check if the window innerWidth is below the width of the desktop screenshots.
    let isMobile = false

    // Only check if this is the client browser
    if (isBrowser) {
      isMobile = window.innerWidth < 900
    }
    
    if (isMobile) {
      const choice = mobile.find(screenshot => screenshot.name === name)

      if (choice) {
        return choice
      }
    }

    const choice = desktop.find(screenshot => screenshot.name === name)

    if (choice) {
      return choice
    }

    return null
  }

  renderWithContext = pageContext => {
    if (pageContext === null) {
      return <div>Component context failure</div>
    }

    const { component, name } = this.props

    const screenshots = pageContext.componentScreenshots[component]

    if (!name) {
      return (
        <div>
          Screenshots available:
          <ul>
            {screenshots.desktop
              .map(screenshot => screenshot.name)
              .map(n => (
                <li>{n}</li>
              ))}
          </ul>
        </div>
      )
    }

    const info = this.getScreenshotInfo(pageContext)

    if (info === null) {
      return (
        <div>
          <VisualTodoNote note={`No screenshot available for ${component}: ${name}`}/>
        </div>
      )
    }

    return (
      <div style={{ textAlign: 'center' }}>
        <img
          src={info.src}
          srcSet={info.srcSet}
          alt={`Screenshot of component ${component} ${name}`}
        />
      </div>
    )
  }

  render() {
    return (
      <PassPageContext.Consumer>
        {pageContext => this.renderWithContext(pageContext)}
      </PassPageContext.Consumer>
    )
  }
}

export default ComponentScreenshot
